// Background
export const ONBOARDING_BACKGROUND = "/img/onboarding/background.png"

// Currency
export const CURRENCY_CRYPTO = "/img/onboarding/currency/crypto.png"
export const CURRENCY_USD = "/img/onboarding/currency/usd.png"

// Rewards treasures
export const TREASURE_0 = "/img/onboarding/rewards/treasure-0.png"
export const TREASURE_1 = "/img/onboarding/rewards/treasure-1.png"
export const TREASURE_2 = "/img/onboarding/rewards/treasure-2.png"
export const TREASURE_3 = "/img/onboarding/rewards/treasure-3.png"
export const TREASURE_4 = "/img/onboarding/rewards/treasure-4.png"
export const TREASURE_5 = "/img/onboarding/rewards/treasure-5.png"
export const TREASURE_6 = "/img/onboarding/rewards/treasure-6.png"

// Rewards activities
export const COMPLETE_VOYAGES = "/img/onboarding/rewards/complete-voyages.png"
export const DISCOVER_TREASURES =
  "/img/onboarding/rewards/discover-treasures.png"
export const EARN_SHIPMENTS = "/img/onboarding/rewards/earn-shipments.png"
export const STAY_LOYAL = "/img/onboarding/rewards/stay-loyal.png"

// Persona
export const PERSONA_COLLECTOR = "/img/onboarding/persona/collector.png"
export const PERSONA_ADVANCED = "/img/onboarding/persona/pro.png"

// Studio onboarding
export const STUDIO_SCHEDULED_DROP = "/img/studio/create/scheduled-drop.png"
export const STUDIO_OPEN_COLLECTION = "/img/studio/create/open-collection.png"

// Badge variants - Fire levels
export const FIRE_LEVEL_0 = "/img/rewards/badge-static/FireLevel0.png"
export const FIRE_LEVEL_1 = "/img/rewards/badge-static/FireLevel1.png"
export const FIRE_LEVEL_2 = "/img/rewards/badge-static/FireLevel2.png"
export const FIRE_LEVEL_3 = "/img/rewards/badge-static/FireLevel3.png"
export const FIRE_LEVEL_4 = "/img/rewards/badge-static/FireLevel4.png"
export const FIRE_LEVEL_5 = "/img/rewards/badge-static/FireLevel5.png"

// Badge variants - Water levels
export const WATER_LEVEL_0 = "/img/rewards/badge-static/WaterLevel0.png"
export const WATER_LEVEL_1 = "/img/rewards/badge-static/WaterLevel1.png"
export const WATER_LEVEL_2 = "/img/rewards/badge-static/WaterLevel2.png"
export const WATER_LEVEL_3 = "/img/rewards/badge-static/WaterLevel3.png"
export const WATER_LEVEL_4 = "/img/rewards/badge-static/WaterLevel4.png"
export const WATER_LEVEL_5 = "/img/rewards/badge-static/WaterLevel5.png"

// Badge variants - Air levels
export const AIR_LEVEL_0 = "/img/rewards/badge-static/AirLevel0.png"
export const AIR_LEVEL_1 = "/img/rewards/badge-static/AirLevel1.png"
export const AIR_LEVEL_2 = "/img/rewards/badge-static/AirLevel2.png"
export const AIR_LEVEL_3 = "/img/rewards/badge-static/AirLevel3.png"
export const AIR_LEVEL_4 = "/img/rewards/badge-static/AirLevel4.png"
export const AIR_LEVEL_5 = "/img/rewards/badge-static/AirLevel5.png"

// Badge variants - Rally levels
export const RALLY_LEVEL_0 = "/img/rewards/badge-static/RallyLevel0.png"
export const RALLY_LEVEL_1 = "/img/rewards/badge-static/RallyLevel1.png"
export const RALLY_LEVEL_2 = "/img/rewards/badge-static/RallyLevel2.png"
export const RALLY_LEVEL_3 = "/img/rewards/badge-static/RallyLevel3.png"
export const RALLY_LEVEL_4 = "/img/rewards/badge-static/RallyLevel4.png"
export const RALLY_LEVEL_5 = "/img/rewards/badge-static/RallyLevel5.png"

// Badge variants - Sailboat tiers (V2 Voyager's Beacon)
export const SAILBOAT_TIER_1 = "/img/rewards/badge-static/Sailboat_Tier_1.png"
export const SAILBOAT_TIER_2 = "/img/rewards/badge-static/Sailboat_Tier_2.png"
export const SAILBOAT_TIER_3 = "/img/rewards/badge-static/Sailboat_Tier_3.png"
export const SAILBOAT_TIER_4 = "/img/rewards/badge-static/Sailboat_Tier_4.png"
export const SAILBOAT_TIER_5 = "/img/rewards/badge-static/Sailboat_Tier_5.png"
export const SAILBOAT_TIER_6 = "/img/rewards/badge-static/Sailboat_Tier_6.png"
export const SAILBOAT_TIER_7 = "/img/rewards/badge-static/Sailboat_Tier_7.png"
export const SAILBOAT_TIER_8 = "/img/rewards/badge-static/Sailboat_Tier_8.png"
export const SAILBOAT_TIER_9 = "/img/rewards/badge-static/Sailboat_Tier_9.png"
export const SAILBOAT_TIER_10 = "/img/rewards/badge-static/Sailboat_Tier_10.png"
export const SAILBOAT_TIER_11 = "/img/rewards/badge-static/Sailboat_Tier_11.png"
export const SAILBOAT_TIER_12 = "/img/rewards/badge-static/Sailboat_Tier_12.png"

// Badge variants - Mariner's Cache tiers (Treasure Chest V2)
export const TREASURE_CHEST_1 = "/img/rewards/badge-static/Treasure_Chest_1.png"
export const TREASURE_CHEST_2 = "/img/rewards/badge-static/Treasure_Chest_2.png"
export const TREASURE_CHEST_3 = "/img/rewards/badge-static/Treasure_Chest_3.png"
export const TREASURE_CHEST_4 = "/img/rewards/badge-static/Treasure_Chest_4.png"
export const TREASURE_CHEST_5 = "/img/rewards/badge-static/Treasure_Chest_5.png"
export const TREASURE_CHEST_6 = "/img/rewards/badge-static/Treasure_Chest_6.png"
export const TREASURE_CHEST_7 = "/img/rewards/badge-static/Treasure_Chest_7.png"
export const TREASURE_CHEST_8 = "/img/rewards/badge-static/Treasure_Chest_8.png"
export const TREASURE_CHEST_9 = "/img/rewards/badge-static/Treasure_Chest_9.png"
export const TREASURE_CHEST_10 =
  "/img/rewards/badge-static/Treasure_Chest_10.png"
export const TREASURE_CHEST_11 =
  "/img/rewards/badge-static/Treasure_Chest_11.png"
export const TREASURE_CHEST_12 =
  "/img/rewards/badge-static/Treasure_Chest_12.png"

// Learn center
export const LEARN_HOW_TO_BUY_NFT = "/img/learn-center/how-to-buy-nft.png"
export const LEARN_HOW_TO_CREATE_NFT = "/img/learn-center/how-to-create-nft.png"
export const LEARN_HOW_TO_SELL_NFT = "/img/learn-center/how-to-sell-nft.png"
export const LEARN_STAY_PROTECTED_WEB3 =
  "/img/learn-center/stay-protected-web3.png"
export const LEARN_WHAT_IS_CRYPTO_WALLET =
  "/img/learn-center/what-is-crypto-wallet.png"
export const LEARN_WHAT_IS_MINTING = "/img/learn-center/what-is-minting.png"
export const LEARN_WHAT_IS_NFT = "/img/learn-center/what-is-nft.png"
export const LEARN_WHO_IS_OPENSEA = "/img/learn-center/who-is-opensea.png"

// Rewards shipment
export const SHIPMENT_LOCKED = "/img/rewards/shipment/locked.png"
export const SHIPMENT_UNLOCKED = "/img/rewards/shipment/unlocked.png"
export const SHIPMENT_UNLOCKED_XP = "/img/rewards/shipment/unlocked-xp.png"

// Studio components
export const STUDIO_TEXT_OVER_BACKGROUND =
  "/img/studio/text-over-background.png"
export const STUDIO_TEXT_AND_MEDIA = "/img/studio/text-and-media.png"
export const STUDIO_BACKGROUND_MEDIA = "/img/studio/background-media.png"
export const STUDIO_TEXT_BLOCK = "/img/studio/text-block.png"
export const STUDIO_TEXT_BLOCK_DARK = "/img/studio/text-block-dark.png"
export const STUDIO_TEAM_MEMBERS = "/img/studio/team-members.png"
export const STUDIO_TEAM_MEMBERS_DARK = "/img/studio/team-members-dark.png"
export const STUDIO_FEATURED_COLLECTIONS =
  "/img/studio/featured-collections.png"
export const STUDIO_TIMELINE = "/img/studio/timeline.png"
export const STUDIO_FREEFORM = "/img/studio/free-form.png"
export const STUDIO_FAQ = "/img/studio/faq.png"

// Collection overview
export const COLLECTION_OVERVIEW_PREVIEW = "/img/studio/section.png"

// Galleries
export const GALLERY_CREATE = "/img/galleries/create-gallery.png"

// Rewards How It Works Modal - Quest Cards
export const QUEST_CARD_LIGHT = "/img/rewards/how-it-works/QuestCardLight.png"
export const QUEST_CARD_DARK = "/img/rewards/how-it-works/QuestCardDark.png"

// Rewards How It Works Modal - Treasures
export const TREASURES_LIGHT = "/img/rewards/how-it-works/TreasuresLight.png"
export const TREASURES_DARK = "/img/rewards/how-it-works/TreasuresDark.png"

// Rewards How It Works Modal - Shipments
export const SHIPMENTS_LIGHT = "/img/rewards/how-it-works/ShipmentsLight.png"
export const SHIPMENTS_DARK = "/img/rewards/how-it-works/ShipmentsDark.png"

// Rewards How It Works Modal - Integrity
export const INTEGRITY_LIGHT = "/img/rewards/how-it-works/IntegrityLight.png"
export const INTEGRITY_DARK = "/img/rewards/how-it-works/IntegrityDark.png"

// Rewards How It Works Modal - Rewards Pool
export const REWARDS_POOL_LIGHT = "/img/rewards/how-it-works/RewardsPool.png"
export const REWARDS_POOL_DARK = "/img/rewards/how-it-works/RewardsPoolDark.png"

// Rewards How It Works Modal - Activity
export const ACTIVITY_LIGHT = "/img/rewards/how-it-works/Activity.png"
export const ACTIVITY_DARK = "/img/rewards/how-it-works/ActivityDark.png"

// Rewards How It Works Modal - Voyages
export const VOYAGES_LIGHT = "/img/rewards/how-it-works/Voyages.png"
export const VOYAGES_DARK = "/img/rewards/how-it-works/VoyagesDark.png"

// Rewards How It Works Modal - Be Rewarded
export const REWARDED_LIGHT = "/img/rewards/how-it-works/Rewarded.png"
export const REWARDED_DARK = "/img/rewards/how-it-works/RewardedDark.png"

// Rewards How It Works Modal - Claim
export const CLAIM_LIGHT = "/img/rewards/how-it-works/Claim.png"
export const CLAIM_DARK = "/img/rewards/how-it-works/ClaimDark.png"

// Rewards Onboarding - Connect Step
export const REWARDS_CONNECT_BANNER = "/img/rewards/onboarding/Banner.png"
export const LINK_WALLETS_IMAGE = "/img/rewards/other/LinkWallets.png"

// Badge Animations - Fire Levels
export const FIRE_LEVEL_0_ANIMATION = "/img/rewards/badge/FireLevel0.json"
export const FIRE_LEVEL_1_ANIMATION = "/img/rewards/badge/FireLevel1.json"
export const FIRE_LEVEL_2_ANIMATION = "/img/rewards/badge/FireLevel2.json"
export const FIRE_LEVEL_3_ANIMATION = "/img/rewards/badge/FireLevel3.json"
export const FIRE_LEVEL_4_ANIMATION = "/img/rewards/badge/FireLevel4.json"
export const FIRE_LEVEL_5_ANIMATION = "/img/rewards/badge/FireLevel5.json"

// Badge Animations - Water Levels
export const WATER_LEVEL_0_ANIMATION = "/img/rewards/badge/WaterLevel0.json"
export const WATER_LEVEL_1_ANIMATION = "/img/rewards/badge/WaterLevel1.json"
export const WATER_LEVEL_2_ANIMATION = "/img/rewards/badge/WaterLevel2.json"
export const WATER_LEVEL_3_ANIMATION = "/img/rewards/badge/WaterLevel3.json"
export const WATER_LEVEL_4_ANIMATION = "/img/rewards/badge/WaterLevel4.json"
export const WATER_LEVEL_5_ANIMATION = "/img/rewards/badge/WaterLevel5.json"

// Badge Animations - Air Levels
export const AIR_LEVEL_0_ANIMATION = "/img/rewards/badge/AirLevel0.json"
export const AIR_LEVEL_1_ANIMATION = "/img/rewards/badge/AirLevel1.json"
export const AIR_LEVEL_2_ANIMATION = "/img/rewards/badge/AirLevel2.json"
export const AIR_LEVEL_3_ANIMATION = "/img/rewards/badge/AirLevel3.json"
export const AIR_LEVEL_4_ANIMATION = "/img/rewards/badge/AirLevel4.json"
export const AIR_LEVEL_5_ANIMATION = "/img/rewards/badge/AirLevel5.json"

// Badge Animations - Rally Levels
export const RALLY_LEVEL_0_ANIMATION = "/img/rewards/badge/RallyLevel0.json"
export const RALLY_LEVEL_1_ANIMATION = "/img/rewards/badge/RallyLevel1.json"
export const RALLY_LEVEL_2_ANIMATION = "/img/rewards/badge/RallyLevel2.json"
export const RALLY_LEVEL_3_ANIMATION = "/img/rewards/badge/RallyLevel3.json"
export const RALLY_LEVEL_4_ANIMATION = "/img/rewards/badge/RallyLevel4.json"
export const RALLY_LEVEL_5_ANIMATION = "/img/rewards/badge/RallyLevel5.json"

// Badge Animations - Voyager's Beacon
export const SAILBOAT_1_ANIMATION = "/img/rewards/badge/Sailboat_1.json"
export const SAILBOAT_2_ANIMATION = "/img/rewards/badge/Sailboat_2.json"
export const SAILBOAT_3_ANIMATION = "/img/rewards/badge/Sailboat_3.json"
export const SAILBOAT_4_ANIMATION = "/img/rewards/badge/Sailboat_4.json"
export const SAILBOAT_5_ANIMATION = "/img/rewards/badge/Sailboat_5.json"
export const SAILBOAT_6_ANIMATION = "/img/rewards/badge/Sailboat_6.json"
export const SAILBOAT_7_ANIMATION = "/img/rewards/badge/Sailboat_7.json"
export const SAILBOAT_8_ANIMATION = "/img/rewards/badge/Sailboat_8.json"
export const SAILBOAT_9_ANIMATION = "/img/rewards/badge/Sailboat_9.json"
export const SAILBOAT_10_ANIMATION = "/img/rewards/badge/Sailboat_10.json"
export const SAILBOAT_11_ANIMATION = "/img/rewards/badge/Sailboat_11.json"
export const SAILBOAT_12_ANIMATION = "/img/rewards/badge/Sailboat_12.json"

// Badge Animations - Mariner's Cache
export const TREASURE_CHEST_1_ANIMATION =
  "/img/rewards/badge/Treasure_Chest_1.json"
export const TREASURE_CHEST_2_ANIMATION =
  "/img/rewards/badge/Treasure_Chest_2.json"
export const TREASURE_CHEST_3_ANIMATION =
  "/img/rewards/badge/Treasure_Chest_3.json"
export const TREASURE_CHEST_4_ANIMATION =
  "/img/rewards/badge/Treasure_Chest_4.json"
export const TREASURE_CHEST_5_ANIMATION =
  "/img/rewards/badge/Treasure_Chest_5.json"
export const TREASURE_CHEST_6_ANIMATION =
  "/img/rewards/badge/Treasure_Chest_6.json"
export const TREASURE_CHEST_7_ANIMATION =
  "/img/rewards/badge/Treasure_Chest_7.json"
export const TREASURE_CHEST_8_ANIMATION =
  "/img/rewards/badge/Treasure_Chest_8.json"
export const TREASURE_CHEST_9_ANIMATION =
  "/img/rewards/badge/Treasure_Chest_9.json"
export const TREASURE_CHEST_10_ANIMATION =
  "/img/rewards/badge/Treasure_Chest_10.json"
export const TREASURE_CHEST_11_ANIMATION =
  "/img/rewards/badge/Treasure_Chest_11.json"
export const TREASURE_CHEST_12_ANIMATION =
  "/img/rewards/badge/Treasure_Chest_12.json"

// Chest Animations - Fire
export const FIRE_CHEST_CLOSED_ANIMATION =
  "/img/rewards/chests/FireChestClosed.json"
export const FIRE_CHEST_OPENED_ANIMATION =
  "/img/rewards/chests/FireChestOpened.json"

// Chest Animations - Water
export const WATER_CHEST_CLOSED_ANIMATION =
  "/img/rewards/chests/WaterChestClosed.json"
export const WATER_CHEST_OPENED_ANIMATION =
  "/img/rewards/chests/WaterChestOpened.json"

// Chest Animations - Air
export const AIR_CHEST_CLOSED_ANIMATION =
  "/img/rewards/chests/AirChestClosed.json"
export const AIR_CHEST_OPENED_ANIMATION =
  "/img/rewards/chests/AirChestOpened.json"

// Monthly Treasure Chest
export const MONTHLY_TREASURE_CHEST = "/img/rewards/chests/WoodChest.png"

// Open Chest Levels (Unlocked chests)
export const OPEN_CHEST_LEVEL_1 = "/img/rewards/chests/OpenLevel1.png"
export const OPEN_CHEST_LEVEL_2 = "/img/rewards/chests/OpenLevel2.png"
export const OPEN_CHEST_LEVEL_3 = "/img/rewards/chests/OpenLevel3.png"
export const OPEN_CHEST_LEVEL_4 = "/img/rewards/chests/OpenLevel4.png"
export const OPEN_CHEST_LEVEL_5 = "/img/rewards/chests/OpenLevel5.png"
export const OPEN_CHEST_LEVEL_6 = "/img/rewards/chests/OpenLevel6.png"
export const OPEN_CHEST_LEVEL_7 = "/img/rewards/chests/OpenLevel7.png"
export const OPEN_CHEST_LEVEL_8 = "/img/rewards/chests/OpenLevel8.png"
export const OPEN_CHEST_LEVEL_9 = "/img/rewards/chests/OpenLevel9.png"
export const OPEN_CHEST_LEVEL_10 = "/img/rewards/chests/OpenLevel10.png"
export const OPEN_CHEST_LEVEL_11 = "/img/rewards/chests/OpenLevel11.png"
export const OPEN_CHEST_LEVEL_12 = "/img/rewards/chests/OpenLevel12.png"

// Closed Chest Levels (Locked chests)
export const CLOSED_CHEST_LEVEL_1 = "/img/rewards/chests/ClosedLevel1.png"
export const CLOSED_CHEST_LEVEL_2 = "/img/rewards/chests/ClosedLevel2.png"
export const CLOSED_CHEST_LEVEL_3 = "/img/rewards/chests/ClosedLevel3.png"
export const CLOSED_CHEST_LEVEL_4 = "/img/rewards/chests/ClosedLevel4.png"
export const CLOSED_CHEST_LEVEL_5 = "/img/rewards/chests/ClosedLevel5.png"
export const CLOSED_CHEST_LEVEL_6 = "/img/rewards/chests/ClosedLevel6.png"
export const CLOSED_CHEST_LEVEL_7 = "/img/rewards/chests/ClosedLevel7.png"
export const CLOSED_CHEST_LEVEL_8 = "/img/rewards/chests/ClosedLevel8.png"
export const CLOSED_CHEST_LEVEL_9 = "/img/rewards/chests/ClosedLevel9.png"
export const CLOSED_CHEST_LEVEL_10 = "/img/rewards/chests/ClosedLevel10.png"
export const CLOSED_CHEST_LEVEL_11 = "/img/rewards/chests/ClosedLevel11.png"
export const CLOSED_CHEST_LEVEL_12 = "/img/rewards/chests/ClosedLevel12.png"

export const MYSTERY_CHEST_LEVEL_1 = "/img/rewards/chests/ColorMysteryChest.png"

export const TREASURE_CHEST_REWARD_CELEBRATION =
  "/img/rewards/treasure-chest-reward.png"

// Treasure Chest Rive Animations
export const TREASURE_CHEST_RIVE_LEVEL_1 =
  "/img/rewards/rive/opensea_chest_1.riv"
export const TREASURE_CHEST_RIVE_LEVEL_2 =
  "/img/rewards/rive/opensea_chest_2.riv"
export const TREASURE_CHEST_RIVE_LEVEL_3 =
  "/img/rewards/rive/opensea_chest_3.riv"
export const TREASURE_CHEST_RIVE_LEVEL_4 =
  "/img/rewards/rive/opensea_chest_4.riv"
export const TREASURE_CHEST_RIVE_LEVEL_5 =
  "/img/rewards/rive/opensea_chest_5.riv"
export const TREASURE_CHEST_RIVE_LEVEL_6 =
  "/img/rewards/rive/opensea_chest_6.riv"
export const TREASURE_CHEST_RIVE_LEVEL_7 =
  "/img/rewards/rive/opensea_chest_7.riv"
export const TREASURE_CHEST_RIVE_LEVEL_8 =
  "/img/rewards/rive/opensea_chest_8.riv"
export const TREASURE_CHEST_RIVE_LEVEL_9 =
  "/img/rewards/rive/opensea_chest_9.riv"
export const TREASURE_CHEST_RIVE_LEVEL_10 =
  "/img/rewards/rive/opensea_chest_10.riv"
export const TREASURE_CHEST_RIVE_LEVEL_11 =
  "/img/rewards/rive/opensea_chest_11.riv"
export const TREASURE_CHEST_RIVE_LEVEL_12 =
  "/img/rewards/rive/opensea_chest_12.riv"

// Rive Smoke Effect
export const SMOKE_EFFECT = "/img/rewards/rive/smoke_effect.riv"

// General Animations
export const ANIMATED_XP = "/img/rewards/animated-xp.json"
export const ANIMATED_XP_DARK = "/img/rewards/animated-xp-dark.json"

// Career assets
// Careers page asset paths following os2-web asset constants pattern

// Hero images
export const CAREERS_HERO_AZUKI = "/img/careers/images/hero/azuki.jpg"
export const CAREERS_HERO_BERA = "/img/careers/images/hero/bera.png"
export const CAREERS_HERO_ETH = "/img/careers/images/hero/eth.svg"
export const CAREERS_HERO_DOODLES = "/img/careers/images/hero/doodles.jpg"
export const CAREERS_HERO_APE = "/img/careers/images/hero/ape.svg"
export const CAREERS_HERO_PENGU = "/img/careers/images/hero/pengu.jpeg"
export const CAREERS_HERO_COOLCATS = "/img/careers/images/hero/coolcats.jpg"
export const CAREERS_HERO_CRYPTOPUNKS =
  "/img/careers/images/hero/cryptopunks.jpg"

// Token images
export const CAREERS_TOKEN_ETHEREUM = "/img/careers/images/tokens/ethereum.svg"
export const CAREERS_TOKEN_AVALANCHE =
  "/img/careers/images/tokens/avalanche.png"
export const CAREERS_TOKEN_POLYGON = "/img/careers/images/tokens/polygon.svg"
export const CAREERS_TOKEN_BASE = "/img/careers/images/tokens/base.png"
export const CAREERS_TOKEN_ABSTRACT = "/img/careers/images/tokens/abstract.svg"
export const CAREERS_TOKEN_MATCAP_REVISED_DARKER =
  "/img/careers/images/matcap-revised-darker.png"

// 3D Assets and geometries
export const CAREERS_GEOMETRY_OPENSEA_SHIP_THIN =
  "/img/careers/geometries/opensea-ship-thin.glb"

export const CAREERS_TEAM_1 = "/img/careers/images/team/team-1.jpg"
export const CAREERS_TEAM_2 = "/img/careers/images/team/team-2.png"
export const CAREERS_TEAM_3 = "/img/careers/images/team/team-3.png"
export const CAREERS_TEAM_4 = "/img/careers/images/team/team-4.png"
export const CAREERS_TEAM_5 = "/img/careers/images/team/team-5.jpg"
export const CAREERS_TEAM_6 = "/img/careers/images/team/team-6.png"
export const CAREERS_TEAM_7 = "/img/careers/images/team/team-7.png"
export const CAREERS_TEAM_8 = "/img/careers/images/team/team-8.png"
export const CAREERS_TEAM_9 = "/img/careers/images/team/team-9.png"
export const CAREERS_TEAM_10 = "/img/careers/images/team/team-10.png"
export const CAREERS_TEAM_11 = "/img/careers/images/team/team-11.jpg"
export const CAREERS_TEAM_12 = "/img/careers/images/team/team-12.jpg"
